import { AgentChat } from "@/components/chat/AgentChat";

export default function Predictor() {
  return <AgentChat agent="predictor" />;
}
